var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2621 33.1779V9.32529C44.2621 6.95386 42.3254 5.19505 39.9738 5.39267H39.8552C35.7052 5.74839 29.4011 7.86291 25.8835 10.0762L25.5476 10.2936C24.9745 10.6493 24.0259 10.6493 23.4528 10.2936L22.9588 9.9972C19.4411 7.80363 13.1569 5.70886 9.00685 5.37291C6.65519 5.17529 4.73828 6.95386 4.73828 9.30553V33.1779C4.73828 35.0751 6.27971 36.8536 8.17685 37.0908L8.74995 37.1698C13.0383 37.7429 19.6585 39.9167 23.4528 41.9917L23.5319 42.0312C24.0654 42.3277 24.9152 42.3277 25.429 42.0312C29.2233 39.9365 35.8633 37.7429 40.1714 37.1698L40.8235 37.0908C42.7207 36.8536 44.2621 35.0751 44.2621 33.1779Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 10.9458V40.5887",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.101 16.8745H11.6545",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5831 22.8027H11.6545",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/book-icon.7d66267511c0845698cae6a87ab68ceb.svg";
export { ForwardRef as ReactComponent };